import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { FaCog, FaEdit } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";
import { languageHelper } from "../../../config/helperFunctions";

function TopBanner() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [columns] = useState([
    {
      header: languageHelper("SN"),
      accessorKey: "id",
    },
    {
      header: languageHelper("Text"),
      accessorKey: "text",
    },

    {
      header: languageHelper("Status"),
      accessorKey: "status",
      cell: (row) => (
        <div className="relative">
          <input
            type="checkbox"
            className="theme-checkbox"
            checked={row.getValue() === "active"}
            onChange={() =>
              updateStatus(row.getValue() === "active" ? "inactive" : "active")
            }
          />
          {isLoading && (
            <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50 z-10 rounded-full">
              <img
                className="w-4 mx-auto"
                src="/assets/gif/button_loader.gif"
                alt=""
              />
            </span>
          )}
        </div>
      ),
    },

    {
      header: languageHelper("Actions"),
      cell: (row) => <ActionDropdown />,
    },
  ]);
  const [data, setData] = useState([]);

  const buttonData = [
    {
      buttonText: languageHelper("Add Top Banner"),
      path: "editTopbanner",
    },
  ];

  const fetchTopBanner = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/topbanner`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setData([res.data.data]);
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token]);

  const updateStatus = (status) => {
    setIsLoading(true);
    axios
      .post(
        `${apiKey}/api/rms/admin/topbanner`,
        {
          text: data[0]?.text,
          status: status,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        },
      )
      .then((res) => {
        fetchTopBanner();
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchTopBanner();
  }, [fetchTopBanner]);

  return (
    <main>
      <CardTable
        error={error}
        data={data}
        columns={columns}
        heading={languageHelper("Top Banner")}
        buttonData={buttonData}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="loading..." />
        </div>
      )}
    </main>
  );
}

function ActionDropdown() {
  const [showDropdown, setShowDropDown] = useState(false);

  return (
    <>
      <div className="relative">
        <button
          className="text-blueGray-500 px-3 flex items-center justify-between gap-1 border rounded-full"
          onClick={() => setShowDropDown(!showDropdown)}
        >
          <FaCog className="text-d-bg-text" />
          <IoIosArrowDown className="text-d-bg-text" />
        </button>
        <div
          className={
            (showDropdown ? "block " : "hidden ") +
            "absolute top-4 left-0 -translate-x-[75%] bg-white text-base z-10 float-left py-2 list-none text-left rounded shadow-lg min-w-40"
          }
        >
          <Link
            to={`editTopbanner`}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaEdit />
            <p> {languageHelper("Edit")} </p>
          </Link>
        </div>
      </div>
    </>
  );
}

export default TopBanner;
